import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import InvestmentApproaches from '@/components/InvestmentApproaches';
import ValuePropositionSection from '@/components/ValuePropositionSection';
import StrategySection from "@/components/StrategySection";
import PortfolioSection from "@/components/PortfolioSection";
import AssetClassesSection from "@/components/AssetClassesSection";
import WhyAlternativesSection from '@/components/WhyAlternativesSection';

const Index = () => {
  return (
    <>
      <HeroSection />
      <WhyAlternativesSection />
      <FeaturesSection />
      <InvestmentApproaches />
      <ValuePropositionSection />
      <StrategySection />
      <PortfolioSection />
      <AssetClassesSection />
    </>
  );
};

export default Index;
